export const FREQUENCY = 'INPUT_MODE';
export const Sum_Assured = 'PR_SA';
export const PR_PT = 'PR_PT';
export const PR_PPT = 'PR_PPT';

export const WOP_RIDER = 'WaiverOfPremiumRider';
export const ADB_RIDER = 'ADBRider';
export const ATPD_RIDER = 'ATPDRider';
export const Critical_ILLNESS_RIDER = 'CriticalIllnessRider';
export const LI_SMOKE = 'LI_SMOKE';